export function capitalizeFirstLetter(string?: string) {
  if (!string) return ''
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function hasLeadingSpaces(str: string): boolean {
  const regex = /^\s+/g
  return regex.test(str)
}

export function hasTrailingSpaces(str: string): boolean {
  const regex = /\s+$/g
  return regex.test(str)
}

export function slugify(text: string) {
  return text
    .toString() // Cast to string (optional)
    .normalize('NFKD') // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string (optional)
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
}

export function randomId() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(2, 10)
}

export const plurify = ({
  final = 's',
  simpleFinal = '',
  count,
  text,
}: {
  count: number
  text: string
  final?: string
  simpleFinal?: string
}) => {
  if (count === 1) return `${text}${simpleFinal}`
  return `${text}${final}`
}

export const getLastPartOfUuid = (uuid: string) => {
  return uuid.split('-').pop()
}
